import React from "react"
import PageTransition from "./src/components/PageTransition"
import ErrorBoundary from "./src/components/ErrorBoundary"

export const wrapPageElement = ({ element, props }) => {
  return (
    <ErrorBoundary>
      <PageTransition {...props}>{element}</PageTransition>
    </ErrorBoundary>
  )
}

export const shouldUpdateScroll = () => {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }

  return false
}

// export const onReportWebVitals = ({ id, name, value }) => {
  
//   // During development: log to console for baseline benchmarking
//   if (process.env.NODE_ENV === "production" && typeof window !== "undefined" && window.Sentry) {
//         console.log(`Web Vital — ${name}: ${Math.round(value)}`)
//   }
  
//   // In production: send to your analytics endpoint
//   // Replace with your actual analytics call if/when you add GA4 or similar
//   if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
//     // Example for GA4:
//     // window.gtag?.("event", name, { value: Math.round(name === "CLS" ? value * 1000 : value), metric_id: id })
//   }

// }